module.exports = __webpack_public_path__ + "static/media/empty-image.81e44ccc.svg";